// Beyond Identity SDK error names (from bi-embedded.js constructors)
const SDK_DATABASE_ERRORS = /databasenotfound|databaseconnectionerror|databaseresulterror|badplatform|operationblocked|unexpectederror/i;
const SDK_DATABASE_MSG = /indexeddb|database|idb/i;

// Browser-native WebAssembly errors
const WASM_NAME = /compileerror/i;
const WASM_MSG = /wasm|webassembly/i;

// Webpack dynamic import errors
const CHUNK_MSG = /loading chunk|chunk.*fail|failed to fetch dynamically imported/i;

// WebAuthn API errors (user biometric cancel/failure)
const BIOMETRIC_NAME = /notallowederror|aborterror/i;
// SDK wraps WebAuthn errors: "HandleUrl(BiAuthenticate(UaAuthenticate(...The operation either timed out or was not allowed..."
const BIOMETRIC_MSG = /biometric|fingerprint|face.*id|touch.*id|user.*cancel|authentication.*cancel|timed out or was not allowed/i;

const CATEGORY_TO_REASON = {
    ChunkLoad: 'chunk load',
    WASMInit: 'wasm init',
    SDKDatabase: 'sdk database',
    Biometric: 'biometric failure',
    SDK: 'sdk error',
    Config: 'config missing',
    API: 'api error'
};

const classifyPasskeyError = error => {
    const msg = (error?.message || error?.errorMessage || '').toLowerCase();
    const name = (error?.name || '').toLowerCase();
    const combined = `${name} ${msg}`;

    if (SDK_DATABASE_ERRORS.test(name) || SDK_DATABASE_MSG.test(msg)) {
        return 'SDKDatabase';
    }

    if (WASM_NAME.test(name) || WASM_MSG.test(combined)) {
        return 'WASMInit';
    }

    if (CHUNK_MSG.test(msg) || name === 'chunkloaderror') {
        return 'ChunkLoad';
    }

    if (BIOMETRIC_NAME.test(name) || BIOMETRIC_MSG.test(msg)) {
        return 'Biometric';
    }

    return 'SDK';
};

/**
 * @param {string} category - Category key (typically from classifyPasskeyError)
 * @returns {string|null} Lowercase reason for Adobe Analytics prop28
 */
const categoryToReason = category => CATEGORY_TO_REASON[category] || null;

const getBuildId = () => {
    const info = Sephora.buildInfo;

    return `${info.BUILD_NUMBER || '?'}.${(info.GIT_COMMIT || '?').substring(0, 7)}`;
};

const logPasskeyForDynatrace = (category, operation, error, flow) => {
    const code = error?.errorCode || error?.code || error?.name || 'UNKNOWN';
    const msg = (error?.message || error?.errorMessage || 'Unknown error').substring(0, 200);
    const build = getBuildId();

    Sephora.logger.error(`Passkey_${category}_${operation},c:${code},m:${msg},f:${flow},b:${build}`);
};

export {
    classifyPasskeyError, categoryToReason, logPasskeyForDynatrace
};
